import { STTLTimeNodePresetClassType } from '@tencent/slide-sdk-pb-model';
import type { ICTTLPoint, ResourceType, STTLTimeNodeType, STSchemeColorVal } from '@tencent/slide-sdk-pb-model';

export const DEFAULT_CLICK_SPID = 'default_click_spid';

export const SequenceTypes = {
    MAIN_SEQ: 'mainSeq',
    INTERACTIVE_SEQ: 'interactiveSeq',
};

// /动画动作效果：  单击时、之前、之后
export const NodeType = {
    NONE: 'none',
    CLICK_EFFECT: 'clickEffect',
    WITH_EFFECT: 'withEffect',
    AFTER_EFFECT: 'afterEffect',
};

// 具体动画类型枚举值，由 presetClass + presetId + presetSubtype 共同决定
export enum AnimType {
    None = 'none',
    FadeIn = 'fade_in', // fade_in
    FadeOut = 'fade_out', // fade_out
    Scale = 'scale', // scale
    Appear = 'appear', // appear
    Disappear = 'disappear',
    FlyIn = 'fly_in',
    FlyOut = 'fly_out',
    FloatUpIn = 'float_up_in',
    FloatUpOut = 'float_up_out',
    FloatDownIn = 'float_down_in',
    FloatDownOut = 'float_down_out',
    CutIn = 'cut_in',
    CutOut = 'cut_out',
    Rotate = 'rotate',
    Plus = 'pluse', // 强调-细微-脉冲
    Spread = 'spread', // 入场-展开
    EnterRotate = 'entr_rotate', // 入场-旋转
    EnterScale = 'entr_scale', // 入场-缩放
    ExitSpread = 'exit_spread', // 退场-收缩
    ExitRotate = 'exit_rotate', // 退场-旋转
    ExitScale = 'exit_scale', //  退场-缩放
    EntrCenterRevolve = 'entr_center_revolve', // 入场-温和-中心旋转
    EntrGrowTurn = 'entr_grow_turn', // 入场-温和-翻转式由远及近
    EntrRiseUp = 'entr_rise_up', // 入场-温和-升起
    EntrSpinner = 'entr_spinner', // 入场-温和-回旋
    EntrBasicZoom = 'entr_basic_zoom', // 入场-温和-基本缩放
    EntrStretch = 'entr_stretch', // 入场-温和-中心旋转
    ExitCenterRevolve = 'exit_center_revolve', // 退场-温和-中心旋转
    ExitShrinkTurn = 'exit_shrink_turn', // 退场-温和-收缩并旋转
    ExitSinkDown = 'exit_sink_down', // 退场-温和-下沉
    ExitSpinner = 'exit_spinner', // 退场-温和-回旋
    ExitBasicZoom = 'exit_basic_zoom', // 退场-温和-基本缩放
    ExitStretch = 'exit_stretch', // 退场-温和-伸展
    ExitCollapse = 'exit_collapse', // 退场-温和-层叠
    EntrBoomerang = 'entr_boomerang', // 入场-华丽-飞旋
    EntrPinwheel = 'entr_pinwheel', // 入场-华丽-玩具风车
    EntrBasicSwivel = 'entr_basic_swivel', // 入场-华丽-基本旋转
    ExitBoomerang = 'exit_boomerang', // 退场-华丽-飞旋
    ExitPinwheel = 'exit_pinwheel', // 退场-华丽-玩具风车
    ExitBasicSwivel = 'exit_basic_swivel', // 退场-华丽-基本旋转
    EmphTransparency = 'emph_transparency', // 强调-基本-透明
    FillColor = 'fill_color', // 强调-基本-填充颜色
    FontColor = 'font_color', // 强调-基本-字体颜色
    LineColor = 'line_color', // 强调-基本-线条颜色
    BrushColor = 'brush_color', // 强调-细微-画笔颜色
    ComplementaryColor = 'complementary_color', // 强调-细微-补色
    ComplementaryColor2 = 'complementary_color2', // 强调-细微-补色2
    ContrastingColor = 'contrasting_color', // 强调-细微-对比色
    Darken = 'darken', // 强调-细微-加深
    Desaturate = 'desaturate', // 强调-细微-不饱和
    Lighten = 'lighten', // 强调-细微-变淡
    ObjectColor = 'object_color', // 强调-细微-对象颜色
    ColorPulse = 'color_pulse', // 强调-温和-彩色脉冲
    GrowWithColor = 'grow_with_color', // 强调-温和-彩色延伸
    Shimmer = 'shimmer', // 强调-温和-闪现
    Teeter = 'teeter', // 强调-温和-跷跷板
    Blink = 'blink', // 强调-华丽-闪烁
    BoldReveal = 'bold_reveal', // 强调-华丽-加粗展示
    Wave = 'wave', // 强调-华丽-波浪形
    BoldFlash = 'bold_flash', // 强调-细微-加粗闪烁
    Underline = 'underline', // 强调-华丽-下划线

    // 路径动画
    Arc = 'arc',
    StraightLine = 'straight_line',
    Cycle = 'cycle',
    Shape = 'shape',
    Turn = 'turn',
    Custom = 'custom',

    // EXPAND_ANIM_TYPES
    EntrCredits = 'entr_credits', // 入场-华丽-字幕式
    ExitCredits = 'exit_credits', // 退场-华丽-字幕式
    EntrBlinds = 'entr_blinds', // 入场-百叶窗
    ExitBlinds = 'exit_blinds', // 退场-百叶窗
    EntrFloat = 'entr_float', // 入场-华丽-浮动
    ExitFloat = 'exit_float', // 退场-华丽-浮动
    EntrCheckerboard = 'entr_checkerboard', // 入场-棋盘
    ExitCheckerboard = 'exit_checkerboard', // 退场-棋盘
    CurveUp = 'curve_up', // 曲线向上
    CurveDown = 'curve_down', // 向下曲线
    EntrWipe = 'entr_wipe', // 入场-擦除
    ExitWipe = 'exit_wipe', // 退场-擦除
    EntrRandomBars = 'entr_random_bars', // 随机线条
    ExitRandomBars = 'exit_random_bars', // 随机线条
    DissolveIn = 'dissolve_in', // 向内溶解
    DissolveOut = 'dissolve_out', // 外向溶解
    EntrSplit = 'entr_split', // 入场-基础-劈裂
    ExitSplit = 'exit_split', // 退场-基础-劈裂
    EntrStrips = 'entr_strips', // 入场-基础-阶梯状
    ExitStrips = 'exit_strips', // 入场-基础-阶梯状
    EntrShapeCircle = 'entr_shape_circle', // 入场-形状-圆形
    ExitShapeCircle = 'exit_shape_circle', // 退场-形状-圆形
    EntrShapeBox = 'entr_shape_box', // 入场-形状-方框
    ExitShapeBox = 'exit_shape_box', // 退场-形状-方框
    EntrShapeDiamond = 'entr_shape_diamond', // 入场-形状-菱形
    ExitShapeDiamond = 'exit_shape_diamond', // 退场-形状-菱形
    EntrShapePlus = 'entr_shape_plus', // 入场-形状-加号
    ExitShapePlus = 'exit_shape_plus', // 退场-形状-加号
    EntrWedge = 'entr_wedge', // 入场-楔入
    ExitWedge = 'exit_wedge', // 退场-楔入
    EntrWheel = 'entr_wheel', // 入场-轮子
    ExitWheel = 'exit_wheel', // 入场-轮子
    EntrBounce = 'entr_bounce', // 入场-华丽-弹跳
    ExitBounce = 'exit_bounce', // 入场-华丽-弹跳
    SpiralIn = 'sprial_in', // 入场=旋转飞入
    SpiralOut = 'sprial_out', // 退场-旋转飞出

    // MEDIA_ANIM_TYPES
    Play = 'play',
    Pause = 'pause',
    Stop = 'stop',
}

// presetClassType枚举值 -> STTLTimeNodePresetClassType

// 基础动画类型枚举值(enter+exit+emph)不一定完整
export enum PresetId {
    None = -1,
    Appear = 1, // 出现，消失
    Fly = 2, // 飞入，飞出
    Stop = 3, // 媒体-停止，百叶窗
    Box = 4, // 形状-方框
    Checkerboard = 5, // 棋盘
    ScaleOrCircle = 6, // 放大，缩小，形状-圆形
    RotateOrDiamond = 8, // 旋转，形状-菱形
    EmphTransparency = 9, // 强调-透明，入场+退场-向内/向外溶解
    Fade = 10, // 淡入，淡出
    Cut = 12, // 切入，切出
    Plus = 13, // 形状-加号
    RandomBars = 14, // 随机线条
    Sprial = 15, // 旋转飞入，旋转飞出
    Split = 16, // 基础-劈裂
    EntrStretch = 17, // 入场-温和-伸展、退场-温和-层叠
    Strips = 18, // 基础-阶梯状
    BasicSwivel = 19, // 入场+退场-基本旋转
    Wedge = 20, // 楔入
    Wheel = 21, // 轮子
    Wipe = 22, // 入场/退场-擦除
    EntrBasicZoom = 23, // 入场+退场-温和-基本缩放
    Boomerang = 25, // 入场+退场—华丽-飞旋
    PluseOrBounce = 26, // 脉冲, 进退场-华丽-弹跳
    Credits = 28, // 入场+退场-字幕式
    Float = 30, // 华丽-浮动
    EntrGrowTurn = 31, // 入场+退场-温和-翻转式由远及近、收缩并旋转
    Pinwheel = 35, // 入场+退场-华丽-玩具风车
    EntrRiseUp = 37, // 入场+退场-温和-升起、下沉
    FloatUp = 42, // 上浮入，上浮出
    EntrCenterRevolve = 43, // 入场+退场-温和-中心旋转
    EntrRotate = 45, // 入场-细微-旋转、出场-细微-旋转
    FloatDown = 47, // 下浮入，下浮出
    EntrSpinner = 49, // 入场+退场-温和-回旋
    ExitStretch = 50, // 退场-温和-伸展
    Curve = 52, // 入场-华丽-曲线向上,退场-华丽-向下曲线
    EntrScale = 53, // 入场-细微-缩放、出场-细微-缩放
    Spread = 55, // 入场-细微-展开、出场-细微-展开
    FillColor = 1, // 强调-基本-填充颜色
    FontColor = 3, // 强调-基本-字体颜色
    LineColor = 7, // 强调-基本-线条颜色
    BrushColor = 16, // 强调-细微-画笔颜色
    ComplementaryColor = 21, // 强调-细微-补色
    ComplementaryColor2 = 22, // 强调-细微-补色2
    ContrastingColor = 23, // 强调-细微-对比色
    Darken = 24, // 强调-细微-加深
    Desaturate = 25, // 强调-细微-不饱和
    Lighten = 30, // 强调-细微-变淡
    ObjectColor = 19, // 强调-细微-对象颜色
    ColorPulse = 27, // 强调-温和-彩色脉
    GrowWithColor = 28, // 强调-温和-彩色延伸
}

// 动画方向枚举值
export enum PresetSubtype {
    None = -1,
    UnSupport = 0,
    Top = 1,
    Right = 2,
    TopRight = 3,
    Bottom = 4,
    Vertical = 5,
    BottomRight = 6,
    Left = 8,
    TopLeft = 9,
    Across = 10,
    BottomLeft = 12,
    EleCenter = 16, // 从元素中心，缩小
    ToSlideBottom = 20,
    VerticalIn = 21, // 左右向中央收缩
    HorizontalIn = 26, // 上下向中央收缩
    ToEleCenter = 32, // 到元素中心，放大
    OutBottom = 36,
    VerticalOut = 37, // 中央向左右展开
    HorizontalOut = 42, // 中央向上下展开
    LeftRight = 110, // 左右
    TopBottom = 111, // 上下
    Total = 112, // 整体
    Clockwise = 113, // 顺时针
    Counterclockwise = 114, // 逆时针
    InSlightly = 272,
    OutSlightly = 288,
    SlideCenter = 528, // 从幻灯片中心
    ToSlideCenter = 544, // 到屏幕中心
}

export enum StraightLinePresetId {
    Down = 42, // 路径动画-直线向下
    Left = 35, // 路径动画-直线向左
    Right = 63, // 路径动画-直线向右
    Up = 64, // 路径动画-直线向上
    RightDown = 49, // 路径动画-直线右下
    RightUp = 56, // 路径动画-直线右上
}

export enum ArcPresetId {
    Down = 37, // 路径动画-向下弧形
    Left = 51, // 路径动画-向左弧形
    Right = 58, // 路径动画-向右弧形
    Up = 44, // 路径动画-向上弧形
}

export enum CyclePresetId {
    Horizontal = 26, // 路径动画-水平循环
    Vertical = 22, // 路径动画-垂直循环
    Repeat = 24, // 路径动画-反复循环
}

export enum ShapePresetId {
    Circle = 1, // 路径动画-圆形
    CurveSquare = 20, // 路径动画-曲线正方形
    Rhombus = 3, // 路径动画-菱形
    EquilateralTriangle = 13, // 路径动画-等边三角形
    Hexagon = 4, // 路径动画-六边形
    Octagon = 10, // 路径动画-八边形
    Parallelogram = 14, // 路径动画-平行四边形
    Pentagon = 15, // 路径动画-五边形
    RightTriangle = 2, // 路径动画-直角三角形
    Square = 7, // 路径动画-正方形
    Ladder = 8, // 路径动画-梯形
}

export enum TurnPresetId {
    Down = 50, // 路径动画-向下转弯
    RightDown = 36, // 路径动画-向右下转弯
    Up = 43, // 路径动画-向上转弯
    RightUp = 57, // 路径动画-向右上转弯
}

export enum MediaPresetId {
    PLAY = 1, // 播放
    PAUSE = 2, // 暂停
}

// 动画id与动画类型映射 - 进入动画
export const ENTR_ID_MAP = {
    [PresetId.Appear]: AnimType.Appear, // 出现
    [PresetId.Fade]: AnimType.FadeIn, // 淡入
    [PresetId.FloatUp]: AnimType.FloatUpIn, // 上浮入
    [PresetId.FloatDown]: AnimType.FloatDownIn, // 下浮入
    [PresetId.Fly]: AnimType.FlyIn, // 飞入
    [PresetId.Cut]: AnimType.CutIn, // 切入
    [PresetId.Spread]: AnimType.Spread, // 入场-细微-展开
    [PresetId.EntrRotate]: AnimType.EnterRotate, // 入场-细微-展开
    [PresetId.EntrScale]: AnimType.EnterScale, // 入场-细微-缩放
    [PresetId.EntrCenterRevolve]: AnimType.EntrCenterRevolve, // 入场-温和-中心旋转
    [PresetId.EntrGrowTurn]: AnimType.EntrGrowTurn, // 入场-温和-翻转式由远及近
    [PresetId.EntrRiseUp]: AnimType.EntrRiseUp, // 入场-温和-升起
    [PresetId.EntrSpinner]: AnimType.EntrSpinner, // 入场-温和-回旋
    [PresetId.EntrBasicZoom]: AnimType.EntrBasicZoom, // 入场-温和-基本缩放
    [PresetId.EntrStretch]: AnimType.EntrStretch, // 入场-温和-中心旋转
    [PresetId.Boomerang]: AnimType.EntrBoomerang, // 入场-华丽-飞旋
    [PresetId.Pinwheel]: AnimType.EntrPinwheel, // 入场-华丽-玩具风车
    [PresetId.BasicSwivel]: AnimType.EntrBasicSwivel, // 入场-华丽-基本旋转
    [PresetId.Credits]: AnimType.EntrCredits, // 入场-字幕式
    [PresetId.Stop]: AnimType.EntrBlinds, // 入场-百叶窗
    [PresetId.Float]: AnimType.EntrFloat, // 入场-华丽-浮动
    [PresetId.Checkerboard]: AnimType.EntrCheckerboard, // 入场-棋盘
    [PresetId.Curve]: AnimType.CurveUp, // 入场-华丽-曲线向上
    [PresetId.Wipe]: AnimType.EntrWipe, // 入场-擦除
    [PresetId.RandomBars]: AnimType.EntrRandomBars, // 入场-随机线条
    [PresetId.EmphTransparency]: AnimType.DissolveIn, // 入场-向内溶解
    [PresetId.Split]: AnimType.EntrSplit, // 入场-基础-劈裂
    [PresetId.Strips]: AnimType.EntrStrips, // 入场-基础-阶梯状
    [PresetId.Box]: AnimType.EntrShapeBox, // 入场-形状-方框
    [PresetId.ScaleOrCircle]: AnimType.EntrShapeCircle, // 入场-形状-圆形
    [PresetId.RotateOrDiamond]: AnimType.EntrShapeDiamond, // 入场-形状-菱形
    [PresetId.Plus]: AnimType.EntrShapePlus, // 入场-形状-加号
    [PresetId.Wedge]: AnimType.EntrWedge, // 入场-楔入
    [PresetId.Wheel]: AnimType.EntrWheel, // 入场-轮子
    [PresetId.PluseOrBounce]: AnimType.EntrBounce, // 入场-华丽-弹跳
    [PresetId.Sprial]: AnimType.SpiralIn, // 入场-旋转飞入
};

// 动画id与动画类型映射 - 退出动画
export const EXIT_ID_MAP = {
    [PresetId.Appear]: AnimType.Disappear, // 消失
    [PresetId.Fade]: AnimType.FadeOut, // 淡出
    [PresetId.Fly]: AnimType.FlyOut, // 飞出
    [PresetId.FloatUp]: AnimType.FloatUpOut, // 上浮出
    [PresetId.FloatDown]: AnimType.FloatDownOut, // 下浮出
    [PresetId.Cut]: AnimType.CutOut, // 切出
    [PresetId.Wipe]: AnimType.ExitWipe, // 退场-擦除
    [PresetId.Spread]: AnimType.ExitSpread, // 出场-细微-展开
    [PresetId.EntrRotate]: AnimType.ExitRotate, // 出场-细微-旋转
    [PresetId.EntrScale]: AnimType.ExitScale, // 出场-细微-缩放
    [PresetId.EntrCenterRevolve]: AnimType.ExitCenterRevolve,
    [PresetId.EntrStretch]: AnimType.ExitCollapse,
    [PresetId.EntrGrowTurn]: AnimType.ExitShrinkTurn,
    [PresetId.EntrRiseUp]: AnimType.ExitSinkDown,
    [PresetId.EntrSpinner]: AnimType.ExitSpinner,
    [PresetId.EntrBasicZoom]: AnimType.ExitBasicZoom,
    [PresetId.ExitStretch]: AnimType.ExitStretch,
    [PresetId.Boomerang]: AnimType.ExitBoomerang, // 退场-华丽-飞旋
    [PresetId.Pinwheel]: AnimType.ExitPinwheel, // 退场-华丽-玩具风车
    [PresetId.BasicSwivel]: AnimType.ExitBasicSwivel, // 退场-华丽-基本旋转
    [PresetId.Credits]: AnimType.ExitCredits, // 退场-字幕式
    [PresetId.Stop]: AnimType.ExitBlinds, // 退场-百叶窗
    [PresetId.Float]: AnimType.ExitFloat, // 退场-华丽-浮动
    [PresetId.Checkerboard]: AnimType.ExitCheckerboard, // 退场-棋盘
    [PresetId.Curve]: AnimType.CurveDown, // 退场-华丽-向下曲线
    [PresetId.RandomBars]: AnimType.ExitRandomBars, // 退场-随机线条
    [PresetId.EmphTransparency]: AnimType.DissolveOut, // 退场-向外溶解
    [PresetId.Split]: AnimType.ExitSplit, // 退场-基础-劈裂
    [PresetId.Strips]: AnimType.ExitStrips, // 退场-基础-阶梯状
    [PresetId.Box]: AnimType.ExitShapeBox, // 退场-形状-方框
    [PresetId.ScaleOrCircle]: AnimType.ExitShapeCircle, // 退场-形状-圆形
    [PresetId.RotateOrDiamond]: AnimType.ExitShapeDiamond, // 退场-形状-菱形
    [PresetId.Plus]: AnimType.ExitShapePlus, // 退场-形状-加号
    [PresetId.Wedge]: AnimType.ExitWedge, // 退场-楔入
    [PresetId.Wheel]: AnimType.ExitWheel, // 退场-轮子
    [PresetId.PluseOrBounce]: AnimType.ExitBounce, // 退场-轮子
    [PresetId.Sprial]: AnimType.SpiralOut, // 退场-旋转飞入
};

// 动画id与动画类型映射 - 强调动画
export const EMPH_ID_MAP = {
    [PresetId.ScaleOrCircle]: AnimType.Scale, // 放大/缩小
    [PresetId.RotateOrDiamond]: AnimType.Rotate, // 旋转
    [PresetId.PluseOrBounce]: AnimType.Plus, // 脉冲
    [PresetId.EmphTransparency]: AnimType.EmphTransparency, // 强调-透明
    [PresetId.FillColor]: AnimType.FillColor, // 强调-基本-填充颜色
    [PresetId.FontColor]: AnimType.FontColor, // 强调-基本-字体颜色
    [PresetId.LineColor]: AnimType.LineColor, // 强调-基本-线条颜色
    [PresetId.BrushColor]: AnimType.BrushColor, // 强调-细微-画笔颜色
    [PresetId.ComplementaryColor]: AnimType.ComplementaryColor, // 强调-细微-补色
    [PresetId.ComplementaryColor2]: AnimType.ComplementaryColor2, // 强调-细微-补色2
    [PresetId.ContrastingColor]: AnimType.ContrastingColor, // 强调-细微-对比色
    [PresetId.Darken]: AnimType.Darken, // 强调-细微-加深
    [PresetId.Desaturate]: AnimType.Desaturate, // 强调-细微-不饱和
    [PresetId.Lighten]: AnimType.Lighten, // 强调-细微-变淡
    [PresetId.ObjectColor]: AnimType.ObjectColor, // 强调-细微-对象颜色
    [PresetId.ColorPulse]: AnimType.ColorPulse, // 强调-温和-彩色脉
    [PresetId.GrowWithColor]: AnimType.GrowWithColor, // 强调-温和-彩色延伸
};

// 动画id与动画类型映射 - 音视频动画
export const MEDIA_ID_MAP = {
    [PresetId.Appear]: AnimType.Play, // 媒体-播放
    [PresetId.Fly]: AnimType.Pause, // 媒体-暂停
    [PresetId.Stop]: AnimType.Stop, // 媒体-停止
};

function getPathIdMap() {
    const idTypeArr = [
        {
            idsObj: StraightLinePresetId,
            type: AnimType.StraightLine,
        },
        {
            idsObj: ArcPresetId,
            type: AnimType.Arc,
        },
        {
            idsObj: CyclePresetId,
            type: AnimType.Cycle,
        },
        {
            idsObj: ShapePresetId,
            type: AnimType.Shape,
        },
        {
            idsObj: TurnPresetId,
            type: AnimType.Turn,
        },
    ];
    const idMap: Record<number, AnimType> = {};
    idTypeArr.forEach((item) => {
        const { idsObj, type } = item;
        Object.values(idsObj).forEach((id) => {
            idMap[id] = type;
        });
    });

    return idMap;
}
export const PATH_ID_MAP = getPathIdMap();

export const ANIM_TYPE_TO_TEMPLATE_KEY = {
    [AnimType.FadeIn]: 'fade_in_tn',
    [AnimType.FadeOut]: 'fade_out_tn',
    [AnimType.Scale]: 'scale',
    [AnimType.Appear]: 'appear',
    [AnimType.Disappear]: 'disappear',
    [AnimType.FlyIn]: 'fly_in',
    [AnimType.FlyOut]: 'fly_out',
    [AnimType.FloatUpIn]: 'float_up_in',
    [AnimType.FloatUpOut]: 'float_up_out',
    [AnimType.FloatDownIn]: 'float_down_in',
    [AnimType.FloatDownOut]: 'float_down_out',
    // TODO cut_in/cut_out 与真实数据差比较多，不确定
    [AnimType.CutIn]: 'cut_in',
    [AnimType.CutOut]: 'cut_out',
    [AnimType.Plus]: 'pluse',
    [AnimType.Rotate]: 'rotate',
    [AnimType.Spread]: 'spread',
    [AnimType.EnterRotate]: 'entr_rotate',
    [AnimType.EnterScale]: 'entr_scale',
    [AnimType.ExitSpread]: 'exit_spread',
    [AnimType.ExitRotate]: 'exit_rotate',
    [AnimType.ExitScale]: 'exit_scale',
    [AnimType.EntrCenterRevolve]: 'entr_center_revolve', // 入场-温和-中心旋转
    [AnimType.EntrGrowTurn]: 'entr_grow_turn', // 入场-温和-翻转式由远及近
    [AnimType.EntrRiseUp]: 'entr_rise_up', // 入场-温和-升起
    [AnimType.EntrSpinner]: 'entr_spinner', // 入场-温和-回旋
    [AnimType.EntrBasicZoom]: 'entr_basic_zoom', // 入场-温和-基本缩放
    [AnimType.EntrStretch]: 'entr_stretch', // 入场-温和-中心旋转
    [AnimType.ExitCenterRevolve]: 'exit_center_revolve', // 退场-温和-中心旋转
    [AnimType.ExitShrinkTurn]: 'exit_shrink_turn', // 退场-温和-收缩并旋转
    [AnimType.ExitSinkDown]: 'exit_sink_down', // 退场-温和-下沉
    [AnimType.ExitSpinner]: 'exit_spinner', // 退场-温和-回旋
    [AnimType.ExitBasicZoom]: 'exit_basic_zoom', // 退场-温和-基本缩放
    [AnimType.ExitStretch]: 'exit_stretch', // 退场-温和-伸展
    [AnimType.ExitCollapse]: 'exit_collapse', // 退场-温和-层叠
    [AnimType.EntrBoomerang]: 'entr_boomerang', // 入场-华丽-飞旋
    [AnimType.EntrPinwheel]: 'entr_pinwheel', // 入场-华丽-玩具风车
    [AnimType.EntrBasicSwivel]: 'entr_basic_swivel', // 入场-华丽-基本旋转
    [AnimType.ExitBoomerang]: 'exit_boomerang', // 退场-华丽-飞旋
    [AnimType.ExitPinwheel]: 'exit_pinwheel', // 退场-华丽-玩具风车
    [AnimType.ExitBasicSwivel]: 'exit_basic_swivel', // 退场-华丽-基本旋转
    [AnimType.EmphTransparency]: 'emph_transparency', // 强调-基本-透明
    [AnimType.EntrCredits]: 'entr_credits', // 入场-华丽-字幕式
    [AnimType.ExitCredits]: 'exit_credits', // 退场-华丽-字幕式
    [AnimType.EntrBlinds]: 'entr_blinds', // 入场-百叶窗
    [AnimType.ExitBlinds]: 'exit_blinds', // 退场-百叶窗
    [AnimType.EntrFloat]: 'entr_float', // 入场-华丽-浮动
    [AnimType.ExitFloat]: 'exit_float', // 退场-华丽-浮动
    [AnimType.EntrCheckerboard]: 'entr_checkerboard', // 入场-棋盘
    [AnimType.ExitCheckerboard]: 'exit_checkerboard', // 退场-棋盘
    [AnimType.CurveUp]: 'curve_up', // 入场-华丽-曲线向上
    [AnimType.CurveDown]: 'curve_down', // 退场-华丽-向下曲线
    [AnimType.EntrWipe]: 'entr_wipe', // 入场-擦除
    [AnimType.ExitWipe]: 'exit_wipe', // 退场-擦除
    [AnimType.EntrRandomBars]: 'entr_random_bars', // 入场-随机线条
    [AnimType.ExitRandomBars]: 'exit_random_bars', // 退场-随机线条
    [AnimType.DissolveIn]: 'dissolve_in', // 入场-向内溶解
    [AnimType.DissolveOut]: 'dissolve_out', // 退场-向外溶解
    [AnimType.EntrSplit]: 'entr_split', // 入场-劈裂
    [AnimType.ExitSplit]: 'exit_split', // 入场-劈裂
    [AnimType.EntrStrips]: 'entr_strips', // 入场-阶梯状
    [AnimType.ExitStrips]: 'exit_strips', // 退场-阶梯状
    [AnimType.EntrShapeCircle]: 'entr_shape_circle', // 入场-形状-圆形
    [AnimType.ExitShapeCircle]: 'exit_shape_circle', // 退场-形状-圆形
    [AnimType.EntrShapeBox]: 'entr_shape_box', // 入场-形状-方框
    [AnimType.ExitShapeBox]: 'exit_shape_box', // 入场-形状-方框
    [AnimType.EntrShapeDiamond]: 'entr_shape_diamond', // 入场-形状-菱形
    [AnimType.ExitShapeDiamond]: 'exit_shape_diamond', // 退场-形状-菱形
    [AnimType.EntrShapePlus]: 'entr_shape_plus', // 退场-形状-加号
    [AnimType.ExitShapePlus]: 'exit_shape_plus', // 退场-形状-加号
    [AnimType.EntrWedge]: 'entr_wedge', // 入场-楔入
    [AnimType.ExitWedge]: 'exit_wedge', // 退场-楔入
    [AnimType.EntrWheel]: 'entr_wheel', // 入场-轮子
    [AnimType.ExitWheel]: 'exit_wheel', // 退场-轮子
    [AnimType.EntrBounce]: 'entr_bounce', // 入场-轮子
    [AnimType.ExitBounce]: 'exit_bounce', // 退场-轮子
    [AnimType.SpiralIn]: 'sprial_in', // 入场-旋转飞入
    [AnimType.SpiralOut]: 'sprial_out', // 退场-旋转飞出
    [AnimType.Play]: 'play', // 播放
    [AnimType.Pause]: 'pause', // 暂停
    [AnimType.Stop]: 'stop', // 停止
    [AnimType.FillColor]: 'fill_color', // 填充颜色
    [AnimType.FontColor]: 'font_color', // 字体颜色
    [AnimType.LineColor]: 'line_color', // 线条颜色
    [AnimType.BrushColor]: 'brush_color', // 画笔颜色
    [AnimType.ComplementaryColor]: 'complementary_color', // 补色
    [AnimType.ComplementaryColor2]: 'complementary_color2', // 补色2
    [AnimType.ContrastingColor]: 'contrasting_color', // 对比色
    [AnimType.Darken]: 'darken', // 加深
    [AnimType.Desaturate]: 'desaturate', // 不饱和
    [AnimType.Lighten]: 'lighten', // 变淡
    [AnimType.ObjectColor]: 'object_color', // 对象颜色
    [AnimType.ColorPulse]: 'color_pulse', // 彩色脉冲
    [AnimType.GrowWithColor]: 'grow_with_color', // 彩色延伸
};

// TODO 这坨看有机会迁移到 tab-template.json 不
export const STRETCH_TAV_MAP = {
    // 从顶端
    1: {
        ppt_x: {
            0: '#ppt_x',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y-#ppt_h/2',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: '#ppt_w',
            100000: '#ppt_w',
        },
        ppt_h: {
            0: 0,
            100000: '#ppt_h',
        },
    },
    // 从底端
    4: {
        ppt_x: {
            0: '#ppt_x',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y+#ppt_h/2',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: '#ppt_w',
            100000: '#ppt_w',
        },
        ppt_h: {
            0: 0,
            100000: '#ppt_h',
        },
    },
    // 从左侧
    8: {
        ppt_x: {
            0: '#ppt_x-#ppt_w/2',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: 0,
            100000: '#ppt_w',
        },
        ppt_h: {
            0: '#ppt_h',
            100000: '#ppt_h',
        },
    },
    // 从右侧
    2: {
        ppt_x: {
            0: '#ppt_x+#ppt_w/2',
            100000: '#ppt_x',
        },
        ppt_y: {
            0: '#ppt_y',
            100000: '#ppt_y',
        },
        ppt_w: {
            0: 0,
            100000: '#ppt_w',
        },
        ppt_h: {
            0: '#ppt_h',
            100000: '#ppt_h',
        },
    },
    // 跨
    10: {
        ppt_w: {
            0: 0,
            100000: '#ppt_w',
        },
        ppt_h: {
            0: '#ppt_h',
            100000: '#ppt_h',
        },
    },
};

export type IPresetSubtypeDict = { first: string; second: string };

// media_xxx动画参数
export type IOriginMediaAnimModifyParam = {
    repeatCount?: string; // 循环播放
    numSld?: number; // 跨页播放
    volume?: number; // 音量
};

export enum ColorKey {
    schemeClr = 'schemeClr',
    srgbClr = 'srgbClr',
}
// color的string不带#，如：{srgbClr: '000000'}
export type IColor = { schemeClr: STSchemeColorVal } | { srgbClr: string };
export type IColorValue = STSchemeColorVal | string | number;

export type IAnimModifyParam = {
    shapeId?: string;
    id?: string;
    dur?: number;
    delay?: string;
    nodeType?: STTLTimeNodeType;
    animType?: AnimType;
    presetSubtype?: PresetSubtype;
    by?: ICTTLPoint | number | string;
    triggerId?: string;
    opacity?: string;
    duration?: string;
    mediaType?: ResourceType;
    audio?: IOriginMediaAnimModifyParam;
    video?: IOriginMediaAnimModifyParam;
    color?: IColor;
};

export enum BehaviorType {
    anim = 'anim',
    animClr = 'animClr',
    animEffect = 'animEffect',
    animMotion = 'animMotion',
    animRot = 'animRot',
    animScale = 'animScale',
    cmd = 'cmd',
    set = 'set',
}

// 主动画队列默认 ID
export const K_DEFAULT_TRIGGER_ID = 'kDefaultTriggerId';
export const PATH_TIMING = 'path_timing';
export const MEDIA_TRIGGER_ID_PREFIX = 'media_';

export const DELAY_RATE_MAP = {
    [AnimType.EntrRiseUp]: 0.9,
    [AnimType.ExitSinkDown]: 0.1,
};
export enum AttrName {
    none = 'NONE',
    rotation = 'style.rotation',
    visibility = 'style.visibility',
    pptX = 'ppt_x',
    pptY = 'ppt_y',
    pptW = 'ppt_w',
    pptH = 'ppt_h',
}
export const SHAPE_ID_PATH = 'cBhvr.tgtEl.spTgt.spid';
export const DUR_PATH = 'cBhvr.cTn.dur';
export const DELAY_PATH = 'cBhvr.cTn.stCondLst.cond[0].delay';
export const WH_ATTR_NAME_LIST = [AttrName.pptW, AttrName.pptH];
export const XY_ATTR_NAME_LIST = [AttrName.pptX, AttrName.pptY];
export const SUPPORT_ANIM_TYPES = [
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Appear,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 出现
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Appear,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 消失
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fade, presetSubtype: PresetSubtype.UnSupport }, // 淡入
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fade, presetSubtype: PresetSubtype.UnSupport }, // 淡出
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.ScaleOrCircle,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 缩放
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Top }, // 从上飞入
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Right }, // 从右飞入
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.TopRight }, // 从右上飞入
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Bottom }, // 从下飞入
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.BottomRight }, // 从右下飞入
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Left }, // 从左飞入
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.TopLeft }, // 从左上飞入
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.Fly, presetSubtype: PresetSubtype.BottomLeft }, // 从左下飞入
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Spread,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-细微-展开
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrRotate,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-细微-旋转
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrScale,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 入场-细微-从对象中心缩放
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrScale,
        presetSubtype: PresetSubtype.SlideCenter,
    }, // 入场-细微-从幻灯片中心缩放
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrCenterRevolve,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-温和-中心旋转
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrGrowTurn,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-温和-翻转式由远及近
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrRiseUp,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-温和-升起
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrSpinner,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-温和-回旋
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 入场-温和-基本缩放-向内
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.SlideCenter,
    }, // 入场-温和-基本缩放-从屏幕中心放大
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.InSlightly,
    }, // 入场-温和-基本缩放-轻微放大
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 入场-温和-基本缩放-向外
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.OutBottom,
    }, // 入场-温和-基本缩放-从屏幕底部缩小
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.OutSlightly,
    }, // 入场-温和-基本缩放-轻微缩小
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Across,
    }, // 入场-温和-伸展-跨
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: PresetId.EntrStretch, presetSubtype: PresetSubtype.Top }, // 入场-温和-伸展-从顶端
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Bottom,
    }, // 入场-温和-伸展-从底端
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Left,
    }, // 入场-温和-伸展-从左侧
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Right,
    }, // 入场-温和-伸展-从右侧
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrCenterRevolve,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-温和-中心旋转
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrGrowTurn,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-温和-收缩并旋转
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrRiseUp,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-温和-下沉
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrSpinner,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-温和-回旋
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 退场-温和-基本缩放-向外
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.ToSlideCenter,
    }, // 退场-温和-基本缩放-缩小到屏幕中心
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.OutSlightly,
    }, // 退场-温和-基本缩放-轻微缩小
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 退场-温和-基本缩放-向内
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.ToSlideBottom,
    }, // 退场-温和-基本缩放-放大到屏幕底部
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrBasicZoom,
        presetSubtype: PresetSubtype.InSlightly,
    }, // 退场-温和-基本缩放-轻微放大
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Across,
    }, // 退场-温和-层叠-跨
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.EntrStretch, presetSubtype: PresetSubtype.Top }, // 退场-温和-层叠-到顶端
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Bottom,
    }, // 退场-温和-层叠-到底端
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Left,
    }, // 退场-温和-层叠-到左侧
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrStretch,
        presetSubtype: PresetSubtype.Right,
    }, // 退场-温和-层叠-到右侧
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.ExitStretch,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-温和-伸展
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Top }, // 从上飞出
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Right }, // 从右飞出
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.TopRight }, // 从右上飞出
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Bottom }, // 从下飞出
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.BottomRight }, // 从右下飞出
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.Left }, // 从左飞出
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.TopLeft }, // 从左上飞出
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: PresetId.Fly, presetSubtype: PresetSubtype.BottomLeft }, // 从左下飞出
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Spread,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-展开
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrRotate,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-旋转
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrScale,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 退场-缩放至对象中心
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EntrScale,
        presetSubtype: PresetSubtype.ToSlideCenter,
    }, // 退场-缩放至幻灯片中心
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.FloatUp,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 上浮入
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.FloatDown,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 下浮入
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.FloatUp,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 上浮出
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.FloatDown,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 下浮出
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Top,
    }, // 切入-从顶部
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Right,
    }, // 切入-从右侧
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Bottom,
    }, // 切入-从底部
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Left,
    }, // 切入-从左侧
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Top,
    }, // 切出-到顶部
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Right,
    }, // 切出-到右侧
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Bottom,
    }, // 切出-到底部
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Cut,
        presetSubtype: PresetSubtype.Left,
    }, // 切出-到左侧
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.RotateOrDiamond,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 旋转
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.PluseOrBounce,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 脉冲
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Boomerang,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-华丽-飞旋
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Pinwheel,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-华丽-玩具风车
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.BasicSwivel,
        presetSubtype: PresetSubtype.Across,
    }, // 入场-华丽-基本旋转-水平
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.BasicSwivel,
        presetSubtype: PresetSubtype.Vertical,
    }, // 入场-华丽-基本旋转-垂直
    { presetClass: STTLTimeNodePresetClassType.entr, presetId: 28, presetSubtype: PresetSubtype.UnSupport }, // 入场-华丽-字幕式
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Boomerang,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-华丽-飞旋
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Pinwheel,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-华丽-玩具风车
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.BasicSwivel,
        presetSubtype: PresetSubtype.Across,
    }, // 退场-华丽-基本旋转-水平
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.BasicSwivel,
        presetSubtype: PresetSubtype.Vertical,
    }, // 退场-华丽-基本旋转-垂直
    { presetClass: STTLTimeNodePresetClassType.exit, presetId: 28, presetSubtype: PresetSubtype.UnSupport }, // 退场-华丽-字幕式
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.EmphTransparency,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 透明
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.FillColor,
        presetSubtype: PresetSubtype.Right,
    }, // 强调-基本-填充颜色
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.FontColor,
        presetSubtype: PresetSubtype.Right,
    }, // 强调-基本-字体颜色
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.LineColor,
        presetSubtype: PresetSubtype.Right,
    }, // 强调-基本-线条颜色
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.BrushColor,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-画笔颜色
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.ComplementaryColor,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-补色
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.ComplementaryColor2,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-补色2
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.ContrastingColor,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-对比色
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.Darken,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-加深
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.Desaturate,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-不饱和
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.Lighten,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-变淡
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.ObjectColor,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-对象颜色
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.ColorPulse,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-彩色脉冲
    {
        presetClass: STTLTimeNodePresetClassType.emph,
        presetId: PresetId.GrowWithColor,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 强调-基本-彩色延伸
    {
        presetClass: STTLTimeNodePresetClassType.mediacall,
        presetId: PresetId.Appear,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 媒体类型
    {
        presetClass: STTLTimeNodePresetClassType.mediacall,
        presetId: PresetId.Fly,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 媒体类型
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: ShapePresetId.Rhombus,
        presetSubtype: PresetSubtype.Across,
    }, // 入场-百叶窗-水平
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: ShapePresetId.Rhombus,
        presetSubtype: PresetSubtype.Vertical,
    }, // 入场-百叶窗-垂直
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: ShapePresetId.Rhombus,
        presetSubtype: PresetSubtype.Across,
    }, // 退场-百叶窗-水平
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: ShapePresetId.Rhombus,
        presetSubtype: PresetSubtype.Vertical,
    }, // 退场-百叶窗-垂直
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Float,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-华丽-浮动
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Float,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-华丽-浮动
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Checkerboard,
        presetSubtype: PresetSubtype.Across,
    }, // 入场-棋盘-横跨
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Checkerboard,
        presetSubtype: PresetSubtype.Across,
    }, // 退场-棋盘-横跨
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Checkerboard,
        presetSubtype: PresetSubtype.Vertical,
    }, // 入场-棋盘-下
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Checkerboard,
        presetSubtype: PresetSubtype.Vertical,
    }, // 退场-棋盘-下
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Curve,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-华丽-曲线向上
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Curve,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-华丽-向下曲线
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Top,
    }, // 入场-擦除-从顶端
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Right,
    }, // 入场-擦除-从右侧
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Bottom,
    }, // 入场-擦除-从底端
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Left,
    }, // 入场-擦除-从右侧
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Top,
    }, // 退场-擦除-从顶端
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Right,
    }, // 退场-擦除-从右侧
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Bottom,
    }, // 退场-擦除-从底端
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wipe,
        presetSubtype: PresetSubtype.Left,
    }, // 退场-擦除-从右侧
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.RandomBars,
        presetSubtype: PresetSubtype.Vertical,
    }, // 入场-随机条纹-垂直
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.RandomBars,
        presetSubtype: PresetSubtype.Across,
    }, // 入场-随机条纹-水平
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.RandomBars,
        presetSubtype: PresetSubtype.Vertical,
    }, // 退场-随机条纹-垂直
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.RandomBars,
        presetSubtype: PresetSubtype.Across,
    }, // 退场-随机条纹-水平
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.EmphTransparency,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-向内溶解
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.EmphTransparency,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-向外溶解
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.HorizontalIn,
    }, // 入场-劈裂-上下向中央收缩
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.HorizontalOut,
    }, // 入场-劈裂-中央向上下展开
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.VerticalIn,
    }, // 入场-劈裂-左右向中央收缩
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.VerticalOut,
    }, // 入场-劈裂-中央向左右展开
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.HorizontalIn,
    }, // 退场-劈裂-上下向中央收缩
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.HorizontalOut,
    }, // 退场-劈裂-中央向上下展开
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.VerticalIn,
    }, // 退场-劈裂-左右向中央收缩
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Split,
        presetSubtype: PresetSubtype.VerticalOut,
    }, // 退场-劈裂-中央向左右展开
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.TopRight,
    }, // 入场-阶梯状-右上
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.BottomRight,
    }, // 入场-阶梯状-右下
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.TopLeft,
    }, // 入场-阶梯状-左上
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.BottomLeft,
    }, // 入场-阶梯状-左下
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.TopRight,
    }, // 退场-阶梯状-右上
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.BottomRight,
    }, // 退场-阶梯状-右下
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.TopLeft,
    }, // 退场-阶梯状-左上
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Strips,
        presetSubtype: PresetSubtype.BottomLeft,
    }, // 退场-阶梯状-左下
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Box,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 入场-形状-方框-缩小
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Box,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 入场-形状-方框-放大
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Box,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 退场-形状-方框-缩小
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Box,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 退场-形状-方框-放大
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.ScaleOrCircle,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 入场-形状-圆形-缩小
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.ScaleOrCircle,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 入场-形状-圆形-放大
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.ScaleOrCircle,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 退场-形状-圆形-缩小
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.ScaleOrCircle,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 退场-形状-圆形-放大
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.RotateOrDiamond,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 入场-形状-菱形-缩小
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.RotateOrDiamond,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 入场-形状-菱形-放大
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.RotateOrDiamond,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 退场-形状-菱形-缩小
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.RotateOrDiamond,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 退场-形状-菱形-放大
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Plus,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 入场-形状-加号-缩小
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Plus,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 入场-形状-加号-放大
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Plus,
        presetSubtype: PresetSubtype.EleCenter,
    }, // 退场-形状-加号-缩小
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Plus,
        presetSubtype: PresetSubtype.ToEleCenter,
    }, // 退场-形状-加号-放大
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wedge,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-楔入
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wedge,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-楔入
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Top,
    }, // 入场-轮子-1 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Top,
    }, // 退场-轮子-1 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Right,
    }, // 入场-轮子-2 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Right,
    }, // 退场-轮子-2 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.TopRight,
    }, // 入场-轮子-3 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.TopRight,
    }, // 退场-轮子-3 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Bottom,
    }, // 入场-轮子-4 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Bottom,
    }, // 退场-轮子-4 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Left,
    }, // 入场-轮子-8 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Wheel,
        presetSubtype: PresetSubtype.Left,
    }, // 退场-轮子-8 轮幅图案
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.PluseOrBounce,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-华丽-弹跳
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.PluseOrBounce,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-华丽-弹跳
    {
        presetClass: STTLTimeNodePresetClassType.entr,
        presetId: PresetId.Sprial,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 入场-旋转飞入
    {
        presetClass: STTLTimeNodePresetClassType.exit,
        presetId: PresetId.Sprial,
        presetSubtype: PresetSubtype.UnSupport,
    }, // 退场-旋转飞出
];
export const MEDIA_VIDEO = {
    cMediaNode: {
        cTn: {
            display: false,
            fill: 3,
            id: '00006a',
            stCondLst: {
                cond: [
                    {
                        delay: 'STTLTimeIndefinite_indefinite',
                    },
                ],
            },
        },
        tgtEl: {
            spTgt: {
                spid: '000064',
            },
        },
        vol: 80000,
    },
};
export const MEDIA_AUDIO = {
    cMediaNode: {
        cTn: {
            stCondLst: {
                cond: [
                    {
                        delay: 'STTLTimeIndefinite_indefinite',
                    },
                ],
            },
            endCondLst: {
                cond: [
                    {
                        tgtEl: {
                            sldTgt: true,
                        },
                        evt: 11,
                        delay: '0',
                    },
                ],
            },
            id: '000064',
            fill: 3,
            display: false,
        },
        tgtEl: {
            spTgt: {
                spid: '00005e',
            },
        },
        vol: 80000,
    },
};
export const PAUSE_DURATION = '1';
export interface IAddAnimationParam {
    shapeIds: string[];
    animType: AnimType;
    triggerId: string;
    index: number;
    presetSubtype?: PresetSubtype;
    mediaDuration?: string;
    delay?: string;
    nodeType?: STTLTimeNodeType;
    mediaType?: ResourceType;
}
export interface IUpdateTimeNodeByAnimType {
    animType: AnimType;
    shapeId: string;
    duration?: string;
    mediaType?: ResourceType;
}

export enum BehaviorAttrName {
    FILL_COLOR = 'fillcolor',
    FONT_COLOR = 'style.color',
    LINE_COLOR = 'stroke.color',
    FILL_TYPE = 'fill.type',
    FILL_ON = 'fill.on',
    FONT_SIZE = 'style.fontSize',
    FONT_WEIGHT = 'style.fontWeight',
}

export const COLOR_ANIM_LIST = [
    AnimType.FillColor,
    AnimType.FontColor,
    AnimType.LineColor,
    AnimType.BrushColor,
    AnimType.ComplementaryColor,
    AnimType.ComplementaryColor2,
    AnimType.ContrastingColor,
    AnimType.Darken,
    AnimType.Desaturate,
    AnimType.Lighten,
    AnimType.ObjectColor,
    AnimType.ColorPulse,
    AnimType.GrowWithColor,
];
